import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { _CreateProductRowvDOS } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { ProductTaxsCatalogForAddedValue } from "../../../../../../Inventories-Warehouses/Product/ProductTaxes/ProductTaxsCatalogForAddedValue";
import { ProductionOrderEditor } from "../../../../../../Factoty&Production/ProductionOrder/ProductionOrderEditor";
import { toast } from "react-toastify";
import { SelectRecurso } from "../../../../../../Factoty&Production/LabourType/SelectRecurso";
import { MaterialAvailableProductionSelect } from "../MaterialAvailableProductionSelect";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";


interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const RawMaterialToProductionLineAction = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {
    const { instance, update, handleChange, deleteItemVoid } = useDataBean(_CreateProductRowvDOS);
    const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState<any>([]);
    const [showFile, setShowFile] = useState<any>(null)
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    // const { lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const [addtable, setAddtable] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [definir, setDefinir] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [prevBean, setPrevBean] = useState<any>(null);



    useEffect(() => {
        if (properties.ProductList)
            setLista(properties.ProductList);
    }, [properties])



    const head = [
        // { title: 'ID', property: 'IDProduct', visible: true },
        { title: 'Producto', property: 'Description', visible: true },
        { title: 'Código Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Unidad Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Costo Unitario', property: 'ProductCost', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        // { title: 'Orden de Producción', property: 'ProductionOrderName', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Fecha de Orden', property: 'ProductionOrderDate', visible: true },


    ]




    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]

    const createProductRowForRawMaterialToProductionLine = () => {
        instance.createProductRowForRawMaterialToProductionLineForDevolution(properties.IDProductionOrder, properties.Year, bean.IDProduct, bean.Quantity, bean.IDStore).then(
            (rta: any) => {
                let x = [...lista];
                x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' })
                setLista(x)
                console.log(rta)
                setModal({ ...modal, "view": false, "name": "Agregar" });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }



    const submitForm = () => {

        let key: any = Object.keys(data);
        // console.log({ [key[0]]: lista });
        // console.log(key[0].EditorObjectClassForName);


        if (setData) {
            setData({ [key[0]]: lista });
        }

    }
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        let temp = [];
        lista.forEach(element => {
            console.log(element);
            console.log(bean);

            if (element.DataBeanProperties != bean) {
                temp.push(element)
            }
        });
        setLista(temp)
        setModalC({ ...modalC, "view": false });
    }

    return (
        <div className="row">
            <div className="col-md-12">

            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createProductRowForRawMaterialToProductionLine}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Producto</label>
                                <MaterialAvailableProductionSelect idProductionOrder={properties.IDProductionOrder} year={properties.Year} render={bean.ProductName} idSelector={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct, "ProductName": e.ProductName, "IDStore": e.IDStore }) }} label=" " returnType="Object" />
                            </div>
                            <div className="col-md-12">
                                <label>Cantidad</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": parseFloat(e.target.value) }) }} />

                            </div>

                        </div>

                    </>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.IDProduct}</strong>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}
                <BasicTable head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />

            </div>

            <div className="col-md-12 mt-4">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Enviar</BasicButton>
            </div>

            <div className="col-md-12">

            </div>
        </div>
    )
}